import BaseConnector from './baseConnector';

export default class IOSConnector extends BaseConnector {
  setStatusBarColor (color) {
    window.webkit.messageHandlers.iOS.postMessage({
      messageType: 'changeTopBarColor',
      messageParams: { color }
    });
  }

  setNavigationBarColor (color) {
    window.webkit.messageHandlers.iOS.postMessage({
      messageType: 'changeBottomBarColor',
      messageParams: { color }
    });
  }

  setModalOpened (modalOpenedData) {
    window.webkit.messageHandlers.iOS.postMessage({
      messageType: 'modalOpened',
      messageParams: modalOpenedData || {}
    });
  }

  setModalClosed () {
    window.webkit.messageHandlers.iOS.postMessage({
      messageType: 'modalClosed',
      messageParams: {}
    });
  }

  onVisitCart (currentFullRoute) {
    window.webkit.messageHandlers.iOS.postMessage({
      messageType: 'onVisitCart',
      messageParams: { url: currentFullRoute } || {}
    });
  }

  onUpdateCart (cartFullRoute) {
    window.webkit.messageHandlers.iOS.postMessage({
      messageType: 'onUpdateCart',
      messageParams: { url: cartFullRoute } || {}
    });
  }

  awayFromCart (currentFullRoute) {
    window.webkit.messageHandlers.iOS.postMessage({
      messageType: 'awayFromCart',
      messageParams: { url: currentFullRoute } || {}
    });
  }

  onClearCart (currentFullRoute) {
    window.webkit.messageHandlers.iOS.postMessage({
      messageType: 'onClearCart',
      messageParams: { url: currentFullRoute } || {}
    });
  }

  getVisitorDetails (tokenValidation) {
    window.webkit.messageHandlers.iOS.postMessage({
      messageType: 'getVisitorDetails',
      messageParams: { tokenValidation }
    });
  }
}
